// Time scale options (MS Teams-style)
export type TimeScale = 60 | 30 | 15 | 10 | 6 | 5;  // minutes

export const TIME_SCALE_OPTIONS: TimeScale[] = [60, 30, 15, 10, 6, 5];

export const TIME_SCALE_LABELS: Record<TimeScale, string> = {
  60: '60 min',
  30: '30 min',
  15: '15 min',
  10: '10 min',
  6: '6 min',
  5: '5 min',
};

// View types
export type CalendarViewType = 'day' | 'week' | 'workweek' | 'month';

export const VIEW_TYPE_LABELS: Record<CalendarViewType, string> = {
  day: 'Day',
  week: 'Week',
  workweek: 'Work Week',
  month: 'Month',
};

// Day view can show 1-7 days
export interface DayViewConfig {
  daysToShow: number;  // 1 to 7
}

export interface CalendarViewState {
  viewType: CalendarViewType;
  dayViewDays: number;  // 1-7, only used when viewType is 'day'
  currentDate: Date;
  selectedDate?: Date;
  timeScale: TimeScale;
}
